import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VehicleService } from '../proxy/general/controllers/vehicle.service';

FieldBuilder.setNamespace('General');

export const MAINTRUCKHISTORIC_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isMainTruck', 'Entity.MainTruckHistoric.IsMainTruck')
    .build(),
  FieldBuilder
    .date('validSince', 'Entity.MainTruckHistoric.ValidSince')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('vehicleId', 'Entity.Vehicle', VehicleService)
    .required()
    .displayFromNested('vehicle.name')
    .sortBy('vehicle.name')
    .build(),
];

export const MAINTRUCKHISTORIC_CONFIG = {
  entityName: 'MainTruckHistoric',
  localizationKey: 'General::Entity.MainTruckHistoric',
  fields: MAINTRUCKHISTORIC_FIELDS,
  permission: 'GeneralMachinesAndVehicles.MainTruckHistorics',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
